import { DensitySmall, StorageOutlined } from '@mui/icons-material'
import { Box } from '@mui/material'
import IconButton from 'components/icon-button'
import { IProjectOrganizationPermissionTableDTO } from 'data/dtos/automation/i-project-dto'
import { useHistory } from 'react-router-dom'
import ChipStatus from 'utils/project/chip-status'
import BadgeConnector from 'utils/project/connector-badge'
import { useStyles } from './styles'

interface ProjectInputTablesViewProps {
  tables: IProjectOrganizationPermissionTableDTO[]
  projectId: string
  organizationId: string
}

const ProjectInputTablesView = ({ tables, projectId, organizationId }: ProjectInputTablesViewProps) => {
  const classes = useStyles()
  const history = useHistory()

  const handleNavigationToTable = (table: IProjectOrganizationPermissionTableDTO) => {
    history.push(`/projects/table/${projectId}/${table.id}/${organizationId}`)
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.headerLine}>
        <div className={classes.headerTitle}>
          <StorageOutlined
            fontSize='medium'
            sx={{ opacity: 0.8 }}
          />
          <h1>Tabelas de Entrada</h1>
        </div>
      </Box>

      <table className={classes.tableBase}>
        <thead className={classes.tableHeader}>
          <tr>
            <th className={classes.tableNameSize}>Nome</th>
            <th className={classes.tableOthersSize}>Origem</th>
            <th className={classes.tableOthersSize}>Registros</th>
            <th className={classes.tableOthersSize}>Status</th>
            <th className={classes.tableActionSize}></th>
          </tr>
        </thead>

        <tbody className={classes.tableBody}>
          {tables.length === 0 && (
            <tr key={Math.random()}>
              <td className={classes.tableNameSize}>
                <span> - </span>
              </td>

              <td className={classes.tableOthersSize}>
                <span> - </span>
              </td>

              <td className={classes.tableOthersSize}>
                <span>0</span>
              </td>

              <td className={classes.tableOthersSize}>
                <ChipStatus text={'Em Espera'} />
              </td>

              <td className={classes.tableActionSize}>
                <IconButton
                  icon={DensitySmall}
                  isDisabled
                  onClick={() => {}}
                  tooltip='Ver Tabelas'
                />
              </td>
            </tr>
          )}

          {tables.map((table) => (
            <tr key={table.id}>
              <td className={classes.tableNameSize}>
                <span>{table.name}</span>
              </td>

              <td className={classes.tableOthersSize}>
                <BadgeConnector name='E-Social' />
              </td>

              <td className={classes.tableOthersSize}>
                <span>{table.records ? table.records : '-'}</span>
              </td>

              <td className={classes.tableOthersSize}>
                <ChipStatus text={table.status as string} />
              </td>

              <td className={classes.tableActionSize}>
                <IconButton
                  icon={DensitySmall}
                  isDisabled={false}
                  onClick={() => handleNavigationToTable(table)}
                  tooltip='Ver Tabelas'
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* <Box className={classes.connectorsLine}>
        {tables.map(({ id, isPermitted, name }) => (
          <ChipConnector
            key={id}
            name={name}
            type={'snowflake'}
            isLoading={false}
            status={isPermitted ? 'authorized' : 'failed'}
          />
        ))}
      </Box> */}
    </Box>
  )
}

export default ProjectInputTablesView
